import React, { } from "react";
import PrintModal from "./PrintModal";
import PersonasBasicInfo, { getPersonasName } from "../Minified/Personas/PersonasBasicInfo";
import PersonasAbout from "../Minified/Personas/PersonasAbout";
import PersonasMarketingApproach from "../Minified/Personas/PersonasMarketingApproach";
import PersonasOtherInfo from "../Minified/Personas/PersonasOtherInfo";
import { useSelector } from "react-redux";
import TrackFeatureServices from "../../services/TrackFeature.services";

const PersonasPrint = ({
    visible,
    onClose = () => { }
}) => {
    const {
        personasParams,
        personasData,
        personasImage
    } = useSelector((state) => state.minified)
    const classColor = personasParams?.classType || "green";
    const onSave = () => {
        TrackFeatureServices.trackFeature("personas download pdf", "download pdf personas", { ...personasData, Image: personasImage })
    }
    return <PrintModal
        visible={visible}
        onClose={onClose}
        onSave={onSave}
        filename={getPersonasName(personasData)}
        pages={[
            <>
                <PersonasBasicInfo
                    classColor={classColor}
                    data={personasData}
                    image={personasImage}
                    targetSize={personasParams.targetSize}
                    forPrint
                />
                <PersonasAbout data={personasData?.["Key Message"]} classColor={classColor} />
                <PersonasMarketingApproach
                    data={personasData?.["Marketing Approach"]}
                    classColor={classColor}
                    forPrint
                />
            </>,
            <PersonasOtherInfo
                data={personasData}
                classColor={classColor}
                forPrint
            />
        ]}
    />
}

export default PersonasPrint